import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { msalInstance } from '../components/Auth/AuthProvider';
import { isAuthConfigured } from '../config/authConfig';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token de autenticación
api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // Solo agregar token si la autenticación está configurada
    if (isAuthConfigured() && msalInstance) {
      const accounts = msalInstance.getAllAccounts();
      
      if (accounts.length > 0) {
        try {
          // Obtener token silenciosamente
          const response = await msalInstance.acquireTokenSilent({
            scopes: ['openid', 'profile', 'email'],
            account: accounts[0],
          });
          
          // Agregar token al header
          config.headers.Authorization = `Bearer ${response.idToken}`;
        } catch (error) {
          console.error('Error obteniendo token:', error);
          // Si falla el token silencioso, intentar interactivo
          try {
            const response = await msalInstance.acquireTokenPopup({
              scopes: ['openid', 'profile', 'email'],
            });
            config.headers.Authorization = `Bearer ${response.idToken}`;
          } catch (popupError) {
            console.error('Error en popup de token:', popupError);
          }
        }
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si es error 401, redirigir a login
    if (error.response?.status === 401 && isAuthConfigured() && msalInstance) {
      console.warn('Token expirado o inválido, redirigiendo a login...');
      msalInstance.logoutRedirect();
    }
    
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;
